/* =========================================================
   Leanne's Cookies — Shopify PDP configurator
   - Doosgrootte = productvariant (prijs volgt de variant)
   - Smaken + kaartje = line item properties (zichtbaar op de orderbon)
   - Validatie: som van de smaken moet exact gelijk zijn aan de doosgrootte
   ========================================================= */
(function () {
  "use strict";

  function initRoot(root) {
    var $ = function (s) { return root.querySelector(s); };
    var $all = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var form = $("[data-leanne-form]");
    var variantInput = $("[data-variant-input]");
    var priceEl = $("[data-price]");
    var locale = root.dataset.locale || "nl-NL";
    var currency = root.dataset.currency || "EUR";

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(cents / 100);
      } catch (e) { return "€" + (cents / 100).toFixed(2).replace(".", ","); }
    };

    var boxes = $all("[data-box]");
    var flavorEls = $all("[data-flavor]");
    var state = { size: 3, priceCents: 0, counts: {}, cardOn: false };
    var orderOpen = true;   // wordt door de bestelklok bijgewerkt
    var cardType = "";      // gekozen kaartje

    flavorEls.forEach(function (el) { state.counts[el.dataset.flavor] = 0; });

    function total() {
      return Object.keys(state.counts).reduce(function (s, k) { return s + state.counts[k]; }, 0);
    }
    function flavorName(id) {
      var el = root.querySelector('[data-flavor="' + CSS.escape(id) + '"]');
      return el ? el.querySelector("[data-flavor-name]").textContent.trim() : id;
    }

    function render() {
      var sum = total(), size = state.size, remaining = size - sum, full = sum === size && size > 0;

      boxes.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.variantId === variantInput.value)); });

      var mCount = $("[data-meter-count]"), mTotal = $("[data-meter-total]"),
          mFill = $("[data-meter-fill]"), mBadge = $("[data-meter-badge]"), meter = $("[data-meter]");
      if (mCount) mCount.textContent = sum;
      if (mTotal) mTotal.textContent = size;
      if (mFill) mFill.style.width = (size ? (sum / size) * 100 : 0) + "%";
      if (meter) meter.classList.toggle("is-full", full);
      if (mBadge) mBadge.textContent = full ? "Doos vol" : "Kies nog " + remaining;

      flavorEls.forEach(function (el) {
        var id = el.dataset.flavor, c = state.counts[id];
        el.querySelector("[data-val]").textContent = c;
        el.querySelector('[data-act="dec"]').disabled = c === 0;
        el.querySelector('[data-act="inc"]').disabled = full;
        el.classList.toggle("has-count", c > 0);
        // line item property: alleen versturen als > 0
        var prop = el.querySelector("[data-flavor-prop]");
        if (prop) { prop.value = c; prop.disabled = c === 0; }
      });

      if (priceEl) priceEl.textContent = money(state.priceCents);

      var list = $("[data-summary]");
      if (list) {
        var chosen = flavorEls.filter(function (el) { return state.counts[el.dataset.flavor] > 0; });
        if (!chosen.length) {
          list.innerHTML = '<li class="summary-empty">Nog geen smaken gekozen</li>';
        } else {
          list.innerHTML = chosen.map(function (el) {
            var id = el.dataset.flavor;
            return "<li><span>" + flavorName(id) + "</span><b>" + state.counts[id] + "×</b></li>";
          }).join("");
          if (state.cardOn) list.innerHTML += '<li style="color:var(--accent-deep)"><span>Kaartje' + (cardType ? " · " + cardType : "") + '</span><b>✓</b></li>';
        }
      }

      // Bij een volle winkelwagen de afrekenknop tonen i.p.v. de vergrendelde knop
      $all("[data-go-cart], [data-sticky-go-cart]").forEach(function (a) { a.hidden = !limitReached; });
      $all("[data-add]").forEach(function (btn) {
        btn.hidden = limitReached;
        btn.disabled = !full || !orderOpen || limitReached;
        var lbl = btn.querySelector("[data-add-label]");
        var isSticky = !!btn.closest("[data-sticky-bar]");
        if (lbl) {
          if (limitReached) lbl.textContent = isSticky ? "Al in winkelwagen" : "Je hebt al een doos in je winkelwagen";
          else if (!orderOpen) lbl.textContent = "Bestellen gesloten";
          else if (full) lbl.textContent = isSticky ? "In winkelwagen" : "In winkelwagen · " + money(state.priceCents);
          else if (sum === 0) lbl.textContent = "Kies nog " + remaining + " koekjes";
          else lbl.textContent = "Nog " + remaining + " te kiezen";
        }
      });

      var sMeta = $("[data-sticky-meta]"), sSize = $("[data-sticky-size]"), sPrice = $("[data-sticky-price]");
      if (sMeta) sMeta.textContent = sum + " van " + size;
      if (sSize) sSize.textContent = size;
      if (sPrice) sPrice.textContent = money(state.priceCents);
    }

    function selectBox(b) {
      variantInput.value = b.dataset.variantId;
      var prevSize = state.size;
      state.size = parseInt(b.dataset.count, 10) || 3;
      state.priceCents = parseInt(b.dataset.priceCents, 10) || 0;
      // Keuze behouden bij wisselen van doosgrootte.
      // Past de selectie niet meer? Dan alleen het teveel eraf halen
      // (laatste smaken eerst), zodat de bezoeker niet opnieuw hoeft te beginnen.
      var sum = 0;
      Object.keys(state.counts).forEach(function (k) { sum += state.counts[k] || 0; });
      if (sum > state.size) {
        var over = sum - state.size;
        var order = flavorEls.map(function (el) { return el.dataset.flavor; }).reverse();
        for (var i = 0; i < order.length && over > 0; i++) {
          var key = order[i];
          var have = state.counts[key] || 0;
          if (!have) continue;
          var take = Math.min(have, over);
          state.counts[key] = have - take;
          over -= take;
        }
      }
      render();
    }

    boxes.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.dataset.variantId === variantInput.value) return;
        selectBox(b);
      });
    });

    flavorEls.forEach(function (el) {
      var id = el.dataset.flavor;
      el.querySelector('[data-act="inc"]').addEventListener("click", function () {
        if (total() < state.size) { state.counts[id]++; render(); }
      });
      el.querySelector('[data-act="dec"]').addEventListener("click", function () {
        if (state.counts[id] > 0) { state.counts[id]--; render(); }
      });
    });

    var cardToggle = $("[data-card-toggle]"), cardField = $("[data-card-field]"),
        cardText = $("[data-card-text]"), cardProp = $("[data-card-prop]"), cardCount = $("[data-card-count]");
    if (cardToggle) {
      cardToggle.addEventListener("click", function () {
        state.cardOn = !state.cardOn;
        cardToggle.classList.toggle("is-on", state.cardOn);
        cardToggle.setAttribute("aria-pressed", String(state.cardOn));
        cardField.classList.toggle("is-open", state.cardOn);
        if (cardProp) cardProp.disabled = !(state.cardOn && cardText.value.trim());
        if (cardTypeProp) { cardTypeProp.value = cardType; cardTypeProp.disabled = !state.cardOn; }
        if (state.cardOn) setTimeout(function () { cardText.focus(); }, 60);
        render();
      });
      cardText.addEventListener("input", function () {
        var len = cardText.value.length;
        if (cardCount) { cardCount.textContent = len + " / 150"; cardCount.classList.toggle("over", len >= 150); }
        if (cardProp) { cardProp.value = cardText.value; cardProp.disabled = !(state.cardOn && cardText.value.trim()); }
      });
    }

    // Configurator leegmaken zodat de bezoeker meteen een nieuwe doos kan samenstellen
    function resetBuilder() {
      Object.keys(state.counts).forEach(function (k) { state.counts[k] = 0; });
      if (state.cardOn) {
        state.cardOn = false;
        if (cardToggle) { cardToggle.classList.remove("is-on"); cardToggle.setAttribute("aria-pressed", "false"); }
        if (cardField) cardField.classList.remove("is-open");
        if (cardText) cardText.value = "";
        if (cardProp) { cardProp.value = ""; cardProp.disabled = true; }
        if (cardTypeProp) { cardTypeProp.value = ""; cardTypeProp.disabled = true; }
        cardOpts.forEach(function (b, i) { b.classList.toggle("is-selected", i === 0); b.setAttribute("aria-checked", String(i === 0)); });
        cardType = cardOpts.length ? cardOpts[0].dataset.card : "";
        if (cardCount) { cardCount.textContent = "0 / 150"; cardCount.classList.remove("over"); }
      }
      render();
    }

    // ---- Winkelwagen-hulp: limiet van 1 doos per bestelling ----
    var MAX_BOXES = parseInt(root.dataset.maxBoxes, 10) || 1;
    var PRODUCT_ID = parseInt(root.dataset.productId, 10) || 0;
    var cartUrl = root.dataset.cartUrl || "/cart";

    // Hoeveel dozen van dit product zitten er al in de winkelwagen?
    function boxesInCart() {
      if (!window.fetch) return Promise.resolve(0);
      return fetch("/cart.js", { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = 0;
          (c.items || []).forEach(function (it) {
            if (!PRODUCT_ID || it.product_id === PRODUCT_ID) n += it.quantity || 0;
          });
          return n;
        })
        .catch(function () { return 0; });
    }

    // Zit de limiet al vol? Dan de configurator vergrendelen met een duidelijke melding.
    var limitReached = false;
    function applyCartLimit() {
      boxesInCart().then(function (n) {
        limitReached = n >= MAX_BOXES;
        var note = $("[data-limit-note]");
        if (note) note.hidden = !limitReached;
        render();
      });
    }

    // ---- Bestelvenster: sluit bestellen tussen deadline en heropening ----
    function parseHM(str, fallbackH, fallbackM) {
      var p = String(str || "").split(":");
      var h = parseInt(p[0], 10), m = parseInt(p[1], 10);
      return { h: isNaN(h) ? fallbackH : h, m: isNaN(m) ? fallbackM : m };
    }
    function orderWindow(now) {
      var cd = parseInt(root.dataset.cutoffDay, 10); if (isNaN(cd)) cd = 2;
      var rd = parseInt(root.dataset.reopenDay, 10); if (isNaN(rd)) rd = 5;
      var ct = parseHM(root.dataset.cutoffTime, 23, 59);
      var rt = parseHM(root.dataset.reopenTime, 9, 0);
      var day = now.getDay(), h = now.getHours(), m = now.getMinutes();

      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), ct.h, ct.m, 0);
      var dd = (cd - day + 7) % 7;
      var afterCutoff = dd === 0 && (h > ct.h || (h === ct.h && m >= ct.m));
      if (afterCutoff) dd = 7;
      cutoff.setDate(cutoff.getDate() + dd);

      var reopen = new Date(now.getFullYear(), now.getMonth(), now.getDate(), rt.h, rt.m, 0);
      var rdd = (rd - day + 7) % 7;
      var beforeReopen = rdd === 0 && (h < rt.h || (h === rt.h && m < rt.m));
      if (rdd === 0 && !beforeReopen) rdd = 7;
      reopen.setDate(reopen.getDate() + rdd);

      // Gesloten = we zitten in het venster tussen deadline en heropening
      var closed = beforeReopen || afterCutoff;
      if (!closed) {
        // Volledig gesloten dagen: als de eerstvolgende heropening eerder valt dan de deadline
        closed = reopen < cutoff;
      }
      return { closed: closed, cutoff: cutoff, reopen: reopen };
    }

    // ---- Kaartje kiezen ----
    var cardOpts = $all("[data-card]");
    var cardTypeProp = $("[data-card-type-prop]");
    cardType = cardOpts.length ? cardOpts[0].dataset.card : "";
    cardOpts.forEach(function (btn) {
      btn.addEventListener("click", function () {
        cardType = btn.dataset.card;
        cardOpts.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle("is-selected", on);
          b.setAttribute("aria-checked", String(on));
        });
        if (cardTypeProp && state.cardOn) cardTypeProp.value = cardType;
        render();
      });
    });

    // ---- Bestelklok: aftellen naar de deadline, of naar heropening ----
    (function orderClock() {
      var band = root.querySelector("[data-ship-timer]");
      var notice = root.querySelector("[data-closed-notice]");
      var noticeClock = root.querySelector("[data-closed-clock]");
      var stickyBarEl = root.querySelector("[data-sticky-bar]");
      var useWindow = root.dataset.orderWindow === "true";
      if (!band && !notice) return;
      var clock = band && band.querySelector("[data-ship-timer-clock]");
      var lead = band && band.querySelector("[data-ship-timer-lead]");
      var sBand = root.querySelector("[data-sticky-timer]");
      var sText = root.querySelector("[data-sticky-timer-text]");
      function pad(n) { return String(n).padStart(2, "0"); }
      function fmt(ms) {
        ms = Math.max(0, ms);
        var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5),
            m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1e3);
        return (d > 0 ? d + (d === 1 ? " dag " : " dagen ") : "") + pad(h) + ":" + pad(m) + ":" + pad(s);
      }
      function tick() {
        var now = new Date();
        var w = orderWindow(now);
        var closed = useWindow && w.closed;
        if (closed !== !orderOpen) { orderOpen = !closed; render(); }
        if (notice) notice.hidden = !closed;
        if (band) band.classList.toggle("is-closed", closed);
        var buy = root.querySelector("[data-buy]");
        if (buy) buy.classList.toggle("is-closed", closed);
        if (closed) {
          var untilOpen = fmt(w.reopen - now);
          if (lead) lead.textContent = "Bestelronde gesloten \u00b7 weer open over";
          if (clock) clock.textContent = untilOpen;
          if (noticeClock) noticeClock.textContent = untilOpen;
          if (sBand) sBand.classList.add("is-closed");
          if (sText) sText.textContent = "Gesloten \u00b7 open over " + untilOpen;
        } else {
          var left = fmt(w.cutoff - now);
          if (lead) lead.textContent = "Bestel binnen";
          if (clock) clock.textContent = left;
          if (sBand) sBand.classList.remove("is-closed");
          if (sText) sText.textContent = "Bestel binnen " + left;
        }
      }
      tick();
      setInterval(tick, 1000);
    })();

    // Toast
    var toast = $("[data-toast]"), toastTimer = null;
    function showToast(msg) {
      if (!toast) return;
      toast.querySelector("[data-toast-msg]").textContent = msg;
      toast.classList.add("is-visible");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove("is-visible"); }, 3500);
    }

    // Add to cart (AJAX; opent de lade i.p.v. door te schieten naar /cart)
    function submitForm(e) {
      if (e) e.preventDefault();
      if (!orderOpen) return;                  // bestelronde gesloten
      if (limitReached) {                      // al een doos in de winkelwagen
        showToast("Je kunt maximaal 1 doos koekjes per keer bestellen.");
        return;
      }
      if (total() !== state.size) {
        var k = root.querySelector("[data-buy]"); if (k) k.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (!form) return;
      if (!window.fetch) { form.submit(); return; } // alleen heel oude browsers
      var data = new FormData(form);
      fetch(root.dataset.cartAddUrl || "/cart/add.js", {
        method: "POST", body: data, headers: { "X-Requested-With": "XMLHttpRequest", "Accept": "application/json" }
      }).then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      }).then(function (res) {
        if (!res.ok) { showToast((res.body && res.body.description) || "Toevoegen mislukt, probeer het opnieuw."); return; }
        // Toegevoegd → gewoon door naar de winkelwagen, zoals de bezoeker verwacht
        try {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
          document.documentElement.dispatchEvent(new CustomEvent("cart:build"));
        } catch (err) {}
        window.location.href = cartUrl;
      }).catch(function () {
        // Alleen bij een echte netwerkfout: melding tonen, NIET wegnavigeren
        showToast("Geen verbinding — probeer het opnieuw.");
      });
    }
    if (form) form.addEventListener("submit", submitForm);
    var stickyAdd = $("[data-sticky-add]");
    if (stickyAdd && form) stickyAdd.addEventListener("click", function (e) { e.preventDefault(); submitForm(e); });

    // Sticky bar zichtbaar zodra de koopknop uit beeld is
    var stickyBar = $("[data-sticky-bar]"), anchor = $("[data-add]");
    if (stickyBar && anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting && window.scrollY > 400;
          stickyBar.classList.toggle("is-visible", show);
          stickyBar.setAttribute("aria-hidden", String(!show));
        });
      }, { rootMargin: "-80px 0px 0px 0px" }).observe(anchor);
    }

    // init op de standaard geselecteerde variant
    var available = boxes.filter(function (b) { return b.dataset.soldout !== "true"; });
    var initial = available.filter(function (b) { return b.dataset.variantId === variantInput.value; })[0] || available[0] || boxes[0];
    if (initial) selectBox(initial); else render();

    // Limiet van 1 doos: bij laden en bij terugkeer via de terugknop opnieuw checken
    applyCartLimit();
    window.addEventListener("pageshow", applyCartLimit);
    document.addEventListener("cart:refresh", applyCartLimit);
  }

  function init() { Array.prototype.slice.call(document.querySelectorAll("[data-leanne-pdp]")).forEach(initRoot); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();